
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import HtmlSourceCodeEditing from './HtmlSourceCodeEditing';
import HtmlSourceCodeUI from './HtmlSourceCodeUI';

export default class HtmlSourceCode extends Plugin {
	
	static get requires() {
		return [ HtmlSourceCodeEditing, HtmlSourceCodeUI ];
	}

	static get pluginName() {
		return 'HtmlSourceCode';
	}
}
